
export const sFechaPublicacion = '2026-11-03T22:52:51.2759628-06:00';
export const sVersion = 'vf1.1.611032252';
            